var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoisture2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Feucht2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #Feucht2 .cls-1 {\n        fill: #26791c;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 7.373)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_114",
    "data-name": "Pfad 114",
    className: "cls-1",
    d: "M20,2.5A17.5,17.5,0,1,1,2.5,20,17.551,17.551,0,0,1,20,2.5M20,0A20,20,0,1,0,40,20,19.978,19.978,0,0,0,20,0Z",
    transform: "translate(-8 -7.373)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2686",
    "data-name": "Pfad 2686",
    className: "cls-1",
    d: "M10.7,22.126A8.816,8.816,0,0,1,8,15.892c0-.091,0-.191,0-.29,0-2.3,1.853-6.108,3.79-9.468C9.83,2.792,7.877,0,7.877,0S0,11.25,0,15.625c0,.084,0,.168,0,.251a7.862,7.862,0,0,0,11.441,6.889,9.132,9.132,0,0,1-.742-.639"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2687",
    "data-name": "Pfad 2687",
    className: "cls-1",
    d: "M24.751,15.625A7.876,7.876,0,1,1,9,15.876c0-.084,0-.167,0-.251C9,11.25,16.876,0,16.876,0s7.875,11.25,7.875,15.625M20.376,13a2,2,0,1,0,2,2,2.151,2.151,0,0,0-2-2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoisture2);
export default __webpack_public_path__ + "static/media/moisture-2.c3721f441f337474722198eb2ec399cc.svg";
export { ForwardRef as ReactComponent };